import * as React from 'react';
import { useSelector } from 'react-redux';
import { Services } from './Services';
import {
  selectServiceIds,
  selectPublishTermsStatus,
  selectActiveServiceIndex,
  selectActiveServiceId,
} from '../../../../selectors/publishTerms';
import { EPublishTermsStatus } from '../../../../redux/reducers';
import { trackSliderScroll, trackServicesShow, trackDiffPricingShow } from './tracking';
import { ElementInViewport } from '../../../common/ElementInViewport';
import { useIsMobileDevice } from '../../../../hooks';
import { selectBetPosition, selectIsBetPositionVisible } from '../../../../selectors/betPosition';
import {
  selectAnalyticsDiffPricingIds,
  selectAnalyticsFormId,
  selectAnalyticsOfferStatus,
  selectAnalyticsProduct,
} from '../../../../selectors/analytics';
import { selectCurrentBet } from '../../../../selectors/auction';

export const ServicesContainer: React.FC<{}> = () => {
  const serviceIds = useSelector(selectServiceIds);
  const status = useSelector(selectPublishTermsStatus);
  const activeServiceIndex = useSelector(selectActiveServiceIndex);
  const isBetPositionVisible = useSelector(selectIsBetPositionVisible);
  const analyticsOfferStatus = useSelector(selectAnalyticsOfferStatus);
  const analyticsProduct = useSelector(selectAnalyticsProduct);
  const activeServiceId = useSelector(selectActiveServiceId)!;
  const betPosition = useSelector(selectBetPosition);
  const bet = useSelector(selectCurrentBet);
  const analyticsFormId = useSelector(selectAnalyticsFormId);
  const diffPricingIds = useSelector(selectAnalyticsDiffPricingIds);

  const isMobile = useIsMobileDevice();

  const { offerPosition = null, page = null } = betPosition || {};

  const handleServicesVisible = React.useCallback(() => {
    trackServicesShow({
      analyticsOfferStatus,
      analyticsProduct,
      serviceIds,
      activeServiceId,
      bet,
      offerPosition,
      page,
      analyticsFormId,
    });

    if (diffPricingIds) {
      const { diffPriceIterationId, diffPriceGranuleGuid } = diffPricingIds;

      trackDiffPricingShow({ analyticsOfferStatus, analyticsFormId, diffPriceIterationId, diffPriceGranuleGuid });
    }
  }, [serviceIds, activeServiceId, bet, offerPosition, page, diffPricingIds]);

  const handleScrollSliderRight = React.useCallback(() => {
    trackSliderScroll({ analyticsOfferStatus, analyticsProduct, analyticsFormId, direction: 'right' });
  }, [analyticsProduct, analyticsFormId]);

  const handleScrollSliderLeft = React.useCallback(() => {
    trackSliderScroll({ analyticsOfferStatus, analyticsProduct, analyticsFormId, direction: 'left' });
  }, [analyticsProduct, analyticsFormId]);

  if (status === EPublishTermsStatus.success) {
    return (
      <ElementInViewport threshold={0.25} onVisible={handleServicesVisible}>
        <Services
          serviceIds={serviceIds}
          isMobile={isMobile}
          isBetPositionVisible={isBetPositionVisible}
          activeServiceIndex={activeServiceIndex}
          onScrollSliderRight={handleScrollSliderRight}
          onScrollSliderLeft={handleScrollSliderLeft}
        />
      </ElementInViewport>
    );
  }

  return null;
};
